
import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormGroup, Button } from 'react-bootstrap'
import { momentHelper } from '../helpers'
import SelectDate from 'component/element/SelectDate'
import Select from 'react-select'
import PrintButtons from 'component/element/PrintButtons'
import ReportStore from 'stores/ReportStore'
import StockStore from 'stores/StockStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import FontAwesome from 'react-fontawesome'
import DatePicker from 'component/element/DatePicker'
import IframeModal from 'component/element/IframeModal'
import Moment from 'moment'
import '../report.css'
// import { connect } from 'react-redux';

class ReportProductTransactionImport extends Component {
  constructor(props) {
    super(props)
    const WHOLE_YEAR = momentHelper.getMonth() //'00'

    this.state = {
      loading:false,
      activePage:1,
      groupId:'tool',
      groupList:[{label:'เครื่องมือช่าง',value:'tool'},{label:'อะไหล่(ทั่วไป)',value:'genpart'},{label:'เบ็ตเตล็ด',value:'officemate'},{label:'สีรถยนต์',value:'color'}],
      recordType:'',
      recordList:[{label:'เข้าและออก',value:''},{label:'เข้า',value:'import'},{label:'ออก',value:'export'}],
      productCat:'',
      productCatList:[{label:'ทั้งหมด',value:''}],
      month:WHOLE_YEAR,
      year:momentHelper.getYear(),
      data:[],
      dataFormat:[],
      isRange:false,
      day:momentHelper.getDay(),
      dayRange:momentHelper.getDay(),
      monthRange:WHOLE_YEAR,
      yearRange:momentHelper.getYear()
    }
    this.refTableId = 'ReportProductTransactionImport-'+Math.ceil(Math.random()*100);
  }

  componentDidMount(){
   
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData(this.state.year,this.state.month,this.state.day,this.state.groupId,this.state.recordType,this.state.productCat)
      this.loadProductCatList('tool')
    }
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    if (all_day) {
      if (all_day<this.state.day) {
        var defaultDay = '00'
      } else {
        var defaultDay = this.state.day
      }
    } else {
      var defaultDay = '00'
    }
    return defaultDay
}

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary(field) {
    let {data} = this.state
    let total = 0
    data.forEach((item,index)=> {
        total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
    }) 
    return total
  }

  getDataFormat(data) {
    let check_date = []
    let dataFormat = []
    let productcode = []
    let added_time= []
    let cost_per_unit = []
    let description = []
    let price_per_unit = []
    let quantity = []
    let unit = []
    let car_registration_no =[]
    let request_by = []

    data = data.map((item,index)=>{
        if (item.added_date!=''&&item.added_date!=null&&item.added_date!=undefined&&item.added_date.split(' ').length>0){
            let datetime = item.added_date.split(' ')
            item.added_date = datetime[0]
            item.added_time = datetime[1]
        }
        return item
    })

    for (var i=0;i<data.length;i++) {
        if (check_date.indexOf(data[i].added_date)==-1) {
          check_date.push(data[i].added_date)
        }
    }

    for (var i=0;i<check_date.length;i++) {
        for (var j=0;j<data.length;j++) {
          if (check_date[i]==data[j].added_date) {
            productcode.push(data[j].productcode)
            added_time.push(data[j].added_time)
            cost_per_unit.push(data[j].cost_per_unit)
            description.push(data[j].description)
            price_per_unit.push(data[j].price_per_unit)
            quantity.push(data[j].quantity)
            unit.push(data[j].unit)
            car_registration_no.push(data[j].car_registration_no)
            request_by.push(data[j].request_by)
          }
        }
        dataFormat.push({
          added_date: check_date[i],
          meta: {
            productcode: productcode,  
            added_time:added_time,
            cost_per_unit: cost_per_unit,
            description: description,
            price_per_unit: price_per_unit,
            quantity: quantity,
            unit: unit,
            car_registration_no:car_registration_no,
            request_by:request_by
          }
        })
        productcode = []
        added_time =[]
        cost_per_unit = []
        description = []
        price_per_unit = []
        quantity = []
        unit = []
        car_registration_no = []
        request_by = []
    }
    
    return dataFormat  
  }

  loadData(year='',month='',day='',groupId='',recordType='',productCat='') {
    this.setState({loading:true,isRange:false,dayRange:momentHelper.getDay(),monthRange:month,yearRange:year})
    ReportStore.loadReportProductTransactionRecord(year,month,day,groupId,recordType,productCat,(result)=>{
      this.setState({loading:false,data:result.data,dataFormat:this.getDataFormat(result.data)})
    })
  }

  loadDataRange(start='',end='',groupId='',recordType='',productCat='') {
    ReportStore.loadReportProductTransactionRecordRange(start,end,groupId,recordType,productCat,(result)=>{
      this.setState({loading:false,data:result.data,dataFormat:this.getDataFormat(result.data)})
    })
  }

  loadProductCatList(groupId) {
    let productCatList = [{label:'ทั้งหมด',value:''}]
    StockStore.loadCategory(groupId,(result)=>{
      result.data.forEach((item,index)=>{
        productCatList.push({
          label:item.name,
          value:item.cat_id
        })
      })
      this.setState({productCatList:productCatList,productCat:''})
    })
  }

  renderBodyCol(recordType,item) {
    if (recordType==='') {
      return([
        <td key={0} className='text-center'><div className=''>{item.record_type==='import'?'เข้า':item.record_type==='export'?'ออก':''}</div></td>,  
        <td key={1} className='text-center'><div className=''>{item.car_registration_no}</div></td>,
        <td key={2} className='text-center'>{item.record_type==='import'?item.request_by:''}</td>,
        <td key={3} className='text-center'>{item.record_type==='import'?item.response_by:item.request_by}</td>
      ])
    } else if (recordType==='import') {  
      return([
        <td key={0} className='text-center '>
          <div className=''>{item.request_by}</div>
        </td>,
        <td key={1} className='text-center '>
          <div className=''>{item.response_by}</div>
        </td> 
      ])  
    } else if (recordType==='export') {  
      return([
        <td key={0} className='text-center '>
          <div className=''>{item.car_registration_no}</div>
        </td>,
        <td key={1} className='text-center '>
          <div className=''>{item.request_by}</div>
        </td> 
      ])  
    }else{
      return ('')
    }
  }

  renderBody(){
    let {data,recordType} = this.state
    if (data.length==0) {
      return(<tr><td colSpan={recordType==''?10:8}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=>
            <tr key={index}>
              <td className='text-center '>
                <div className=''>{item.added_date}</div>
              </td>
              <td className='text-center '>
                <div className=''>{item.added_time}</div>
              </td>
              <td className='text-left '>
                <div className=''>{item.description}</div>
              </td>
              <td className='text-center '>
                <div className=''>{item.quantity}</div>
              </td>
              <td className='text-center '>
                <div className=''>{item.unit}</div>
              </td>
              <td className='text-right '>
                <div className=''>{this.getNumberFormat(item.cost_per_unit)}</div>
              </td>
              {this.renderBodyCol(recordType,item)}
            </tr>
      ))
    }
  }

  renderHeadCol(recordType) {
    if (recordType==='') {
      return([
        <th key={0} className='text-center' style={{width:'100px'}}>ประเภท</th>,  
        <th key={1} className='text-center' style={{width:'110px'}}>ทะเบียนรถ</th>,
        <th key={2} className='text-center' style={{width:'100px'}}>บ.ผู้ขาย</th>,
        <th key={3} className='text-center' style={{width:'100px'}}>นำเข้า/ชื่อผู้เบิก</th>
      ])
    } else if (recordType==='import') {
      return([
        <th key={0} className='text-center' style={{width:'100px'}}>บ.ผู้ขาย</th>,
        <th key={1} className='text-center' style={{width:'100px'}}>ชื่อผู้นำเข้า</th>
      ])  
    } else if (recordType==='export') {
      return([
        <th key={0} className='text-center' style={{width:'100px'}}>ทะเบียนรถ</th>,
        <th key={1} className='text-center' style={{width:'100px'}}>ชื่อผู้เบิก</th>
      ])  
    }else{
      return ('')
    }
  }

  getDate() {
    let {day,year,month,isRange,dayRange,monthRange,yearRange} = this.state
    if (isRange) {
      let start = (day<10?'0'+day:day)+'/'+(month=='00'?'1':month)+'/'+year
      let end = dayRange+'/'+(monthRange<10?'0'+monthRange:monthRange)+'/'+yearRange
      return 'ประจำวันที่ '+start+' - '+end
    } else {
      let text = 'ประจำวันที่ '
      text += day+' '+momentHelper.getMonthText(month)+' '+year
      if (year==='0'||year==='00') {
        text = 'ทั้งหมด'
      } else if (month==='0'||month==='00') {
        text = 'ประจำปี '+year
      } else if (day==='0'||day==='00') {
        text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+year
      }
      return text
    }  
  }

  renderTable() {
    let {recordType} = this.state
    return (
      <div className='display-overflow'>
        <table id={this.refTableId} className='table table-responsive table-hover table-bordered-solid' style={{minWidth:'1280px'}}>
          <thead>
            <tr>
              <th style={{display:'none'}} colSpan={recordType==''?10:8}>รายงานสรุปยอดรับเข้า {this.getDate()}</th>
            </tr>
            <tr>
              <th className='text-center' style={{width:'90px'}}>วันที่</th>
              <th className='text-center' style={{width:'100px'}}>เวลา</th> 
              <th className='text-center' style={{width:'350px'}}>ชื่อรายการ</th>
              <th className='text-center' style={{width:'100px'}}>จำนวน</th>
              <th className='text-center' style={{width:'80px'}}>หน่วย</th>
              <th className='text-center' style={{width:'100px'}}>ต้นทุน</th>
              {this.renderHeadCol(recordType)}
            </tr>
          </thead>
          <tbody>
            {this.renderBody()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={3} className='text-right'>ยอดรวมสุทธิ</th>
              <th className='text-center'>{this.getNumberFormat(this.getSummary('quantity'))}</th>
              <th className='text-right'></th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('cost_per_unit'))}</th>
              <th colSpan={recordType===''?4:2} className='text-right'></th>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey
    })
    // next... load new page
  }

  onDayChange(val){
    this.setState({
      day: val.value, isRange:false
    })
    this.loadData(this.state.year,this.state.month,val.value,this.state.groupId,this.state.recordType,this.state.productCat)
  }

  onMonthChange(val) {
    let date = this.state.year-543+'-'+val.value
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      month: val.value, isRange: false, day:_day
    })
    this.loadData(this.state.year,val.value,_day,this.state.groupId,this.state.recordType,this.state.productCat)
  }

  onYearChange(val) {
    let date = val.value-543+'-'+this.state.month
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      year: val.value, isRange: false, day:_day
    })
    this.loadData(val.value,this.state.month,_day,this.state.groupId,this.state.recordType,this.state.productCat)
  }

  onGroupChange(val) {
    this.setState({
      groupId: val.value, isRange: false
    })
    this.loadData(this.state.year,this.state.month,this.state.day,val.value,this.state.recordType,this.state.productCat)
    this.loadProductCatList(val.value)
  }

  onProductCatChange(val) {
    this.setState({
      productCat: val.value, isRange: false
    })
    this.loadData(this.state.year,this.state.month,this.state.day,this.state.groupId,this.state.recordType,val.value)
  }

  onRecordChange(val) {
    this.setState({
      recordType: val.value, isRange: false
    })
    this.loadData(this.state.year,this.state.month,this.state.day,this.state.groupId,val.value,this.state.productCat)
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = 'รายงานสรุปยอดรับเข้า.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTable(e) {
    const {isRange} = this.state
    let url = ''
    let param = 'PrintReportProductTransactionImport&year='+this.state.year+'&month='+this.state.month+'&day='+this.state.day+'&groupId='+this.state.groupId+'&recordType='+this.state.recordType+'&isRange=false'
    if (isRange) {
        let {day,month,year,dayRange,monthRange,yearRange} = this.state
        let start = day+'/'+(month=='00'?'1':month)+'/'+(year-543)
        let end = dayRange+'/'+monthRange+'/'+(yearRange-543)
        param = 'PrintReportProductTransactionImport&start_date='+start+'&end_date='+end+'&groupId='+this.state.groupId+'&recordType='+this.state.recordType+'&isRange=true'
    }    

    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onStartDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let _day = time.substr(0,2)
      let _month = time.substr(3,2)
      let _year = time.substr(6,10)
      this.setState({day:_day*1,month:_month,year:_year*1,isRange:false})
      this.loadData(_year,_month,_day,this.state.groupId,this.state.recordType,this.state.productCat)
    }
  }

  onEndDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let {day,month,year} = this.state
      let _day = parseInt(time.substr(0,2))
      let _month = parseInt(time.substr(3,5))
      let _year = parseInt(time.substr(6,10))
      this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
      year = year - 543
      _year = _year - 543
      let start = day+'/'+(month=='00'?'1':month)+'/'+year
      let end = _day+'/'+_month+'/'+_year
      this.loadDataRange(start,end,this.state.groupId,this.state.recordType,this.state.productCat)
    }  
  }

  onRangeChange(fromDateString,toDateString,items) {
    let {day,month,year,dayRange,monthRange,yearRange} = this.state
    day = items.from.format('DD')*1
    month = items.from.format('MM')
    year = (items.from.format('YYYY')*1)+543
    dayRange = items.to.format('DD')*1
    monthRange = items.to.format('MM')
    yearRange = (items.to.format('YYYY')*1)+543
    this.setState({isRange:true,day:day,month:month,year:year,dayRange:dayRange,monthRange:monthRange,yearRange:yearRange})
    const start = day+'/'+month+'/'+items.from.format('YYYY')
    const end = dayRange+'/'+monthRange+'/'+items.to.format('YYYY')
    this.loadDataRange(start,end,this.state.groupId,this.state.recordType,this.state.productCat)
  }

  renderWCalendar() {
    return(
      <div style={{display:'inline-flex'}}>
        <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.day=='00'?this.state.dayRange:this.state.day)+'/'+this.state.month+'/'+this.state.year}
                onChange={this.onStartDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={this.state.dayRange+'/'+this.state.monthRange+'/'+this.state.yearRange}
                onChange={this.onEndDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
      </div>
    )
  }

  renderToolbar() {
    return(
      <Form inline>
        <FormGroup style={{verticalAlign:'top'}}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            onDayChange={this.onDayChange.bind(this)}
            dayWCalendar={true}
            renderWCalendar={this.renderWCalendar.bind(this)}
          />
        </FormGroup>  
        <div style={{ width: '150px', display: 'inline-block', marginLeft:'5px' }}>
          <Select
            clearable={false}
            name="form-field-name"
            value={this.state.groupId}
            options={this.state.groupList}
            onChange={this.onGroupChange.bind(this)}
          />
        </div>
        <div style={{ width: '150px', display: 'inline-block', marginLeft:'5px' }}>
          <Select
            clearable={false}
            name="form-field-name"
            value={this.state.productCat}
            options={this.state.productCatList}
            onChange={this.onProductCatChange.bind(this)}
          />
        </div>
        <div style={{ width: '150px', display: 'inline-block', marginLeft:'5px' }}>
          <Select
            clearable={false}
            name="form-field-name"
            value={this.state.recordType}
            options={this.state.recordList}
            onChange={this.onRecordChange.bind(this)}
          />
        </div>
        <FormGroup style={{verticalAlign:'top',marginLeft:'5px',marginTop:'1.5px'}}>
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>
      </Form>
    )
  }

  renderPaging() {
    return (
      <div className="text-center pull-right">
        <Pagination
          prev
          next
          first
          last
          bsSize="medium"
          items={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)} />
      </div>
    )
  }

  getStartDateRangeText() {
    let {day,month,year} = this.state
    let txtMonth = momentHelper.getMonthText(month.toString())
    return day*1+' '+ txtMonth +' '+ year
  }

  getEndDateRangeText() {
    let {dayRange,monthRange,yearRange} = this.state
    dayRange = dayRange==0?1:dayRange
    let txtMonth = momentHelper.getMonthText(monthRange.toString())
    return dayRange +' '+ txtMonth +' '+ yearRange
  }

  onRangeClearClick() {
    this.loadData(this.state.year,this.state.month,this.state.day,this.state.groupId,this.state.recordType,this.state.productCat)
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
  }

  renderDateRange() {
    let {isRange} = this.state
    if (isRange) {
      return(
        <div style={{marginBottom:'10px',display:'flex'}}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;<Button className='btn btn-xs' onClick={this.onRangeClearClick.bind(this)}><FontAwesome name='eraser' />&nbsp;ลบช่วงเวลา</Button>
        </div>
      )
    } else {
      return('')
    }  
  }

  render() {
    const reportName = 'สรุปยอดรับเข้า'
    const reportDateText = momentHelper.getMonthText(this.state.month) + " " + this.state.year
    const title = reportName + ' ' + reportDateText
    const {loading} = this.state
    return (
      <Box loading={loading}>
        <Box.Header border={true}>          
          {this.props.renderMenu()}
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderDateRange()}
          {this.renderTable()}
          {/*this.renderPaging()*/}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
      </Box>
    )
  }
}

ReportProductTransactionImport.defaultProps = {
  show : false
}

export default ReportProductTransactionImport;


// WEBPACK FOOTER //
// ./src/view/report/stock/ReportProductTransactionImport.js